module.exports = __webpack_public_path__ + "static/media/sbom-slide-1.ae9cb237.jpg";